import React from 'react';
import PropTypes from 'prop-types'
import Drawer from 'rc-drawer';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import IndexDetail from './IndexDetail';
import IndexCompareTable from './IndexCompareTable';
import { pluralize, getReturnsByYear } from './utils';

// https://create-react-app.dev/docs/adding-images-fonts-and-files/#adding-svgs
import { ReactComponent as ChevronUp } from './icons/ChevronUp.svg';
import { ReactComponent as ChevronDown } from './icons/ChevronDown.svg';

import 'rc-drawer/assets/index.css';
import 'react-tabs/style/react-tabs.css';
import './Drawer.css';

function DrawerContainer({
    availableIndexes,
    showDrawer,
    handleToggleDrawer,
    currentMatrix,
    currentMatrixName,
    growthPeriod,
    tabIndex,
    handleSelectTabIndex,
}) {
    const [startYear, endYear] = growthPeriod;
    const count = (endYear - startYear) + 1;
    const numberOfYears = pluralize(count, 'year', 's');
    const chartData = getReturnsByYear(currentMatrix, {startYear, endYear});
    const { meta: { currencyCode }} = currentMatrix;
    return (
        <React.Fragment>
            <Drawer
                id="drawer"
                level={null}
                handler={
                    <div id="detail-drawer" className="drawer-handle">
                        <div className="drawer__title">
                            {currentMatrixName}
                            {` - ${startYear} - ${endYear} (${numberOfYears})`}
                            </div>
                        {showDrawer ? <ChevronUp/> : <ChevronDown/>}
                    </div>
                }
                placement={'bottom'}
                width={'100%'}
                height={'55%'}
                open={showDrawer}
                onMaskClick={handleToggleDrawer}
                onHandleClick={handleToggleDrawer}
            >
                <Tabs selectedIndex={tabIndex} onSelect={handleSelectTabIndex}>
                    <TabList>
                        <Tab>Detail</Tab>  {/* tab index 0 */}
                        <Tab>Compare</Tab> {/* tab index 1 */}
                    </TabList>
                    <TabPanel>
                        <IndexDetail
                            startYear={startYear}
                            endYear={endYear}
                            numberOfYears={numberOfYears}
                            chartData={chartData}
                            currencyCode={currencyCode}
                        />
                    </TabPanel>
                    <TabPanel>
                        <IndexCompareTable
                            availableIndexes={availableIndexes}
                            startYear={startYear}
                            endYear={endYear}
                        />
                    </TabPanel>
                </Tabs>
            </Drawer>
        </React.Fragment>
    )
}

DrawerContainer.propTypes = {
    availableIndexes: PropTypes.any.isRequired,
    showDrawer: PropTypes.bool.isRequired,
    handleToggleDrawer: PropTypes.func.isRequired,
    currentMatrix: PropTypes.any.isRequired,// TODO: define shape
    currentMatrixName: PropTypes.string.isRequired,
    growthPeriod: PropTypes.array.isRequired, // TODO: define shape [1994, 2005]?
    tabIndex: PropTypes.number.isRequired,
    handleSelectTabIndex: PropTypes.func.isRequired,
}

export default DrawerContainer

